import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },

  name: {
    fontSize: '1.3rem',
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },

  icon: {
    color: theme.palette.primary.main,
  },

  divider: {
    marginLeft: 12,
    marginRight: 12,
    height: 25,
    alignSelf: 'center',

    [theme.breakpoints.down('xs')]: {
      marginRight: 0,
    },
  },
}));
